import { render, staticRenderFns } from "./NotificationsExplanationDialog.vue?vue&type=template&id=64fd8964&"
import script from "./NotificationsExplanationDialog.vue?vue&type=script&lang=js&"
export * from "./NotificationsExplanationDialog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports